document.addEventListener('DOMContentLoaded', () => {
  const swatchContainer = document.querySelector('body');
  
  swatchContainer.addEventListener('change', (event) => {
    // Handle main product page swatches (your existing code)
    if (event.target.matches('.variant-swatches-color input[type="radio"]')) {
      const colorNameDisplay = document.querySelector('#selected-color-name span');
      const selectedValue = event.target.value;
      const selectedVariantId = event.target.dataset.variantId;
      
      colorNameDisplay.textContent = selectedValue;
      
      // Update ALL hidden inputs with name="id" to the selected variant ID
      const hiddenInputs = document.querySelectorAll('input[type="hidden"][name="id"]');
      hiddenInputs.forEach(input => {
        input.value = selectedVariantId;
      });
      
      const variantPicker = document.querySelector('variant-radios, variant-selects');
      const optionInputs = variantPicker.querySelectorAll('input[type="radio"], select');
      
      optionInputs.forEach(input => {
        if (input.type === 'radio' && input.value === selectedValue) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (input.tagName === 'SELECT') {
          input.value = selectedValue;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    
    // Handle card product swatches (new code for your card products)
    if (event.target.matches('.card-swatch')) {
      const variantId = event.target.dataset.variantId;
      const productHandle = event.target.dataset.productHandle;
      
      if (!variantId) return;
      
      // Find the product card container
      const productCard = event.target.closest('.card-wrapper, .product-card, .card, [data-product-handle]');
      
      if (productCard) {
        // Find or create the hidden input field
        let hiddenInput = productCard.querySelector('input[name="id"]');
        
        if (!hiddenInput) {
          hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'id';
          
          // Find the best place to append the hidden input
          let form = productCard.querySelector('form');
          if (!form) {
            // If no form exists, create one or append to the card
            form = productCard.querySelector('.card__content, .card-information, .card__body');
            if (!form) form = productCard;
          }
          form.appendChild(hiddenInput);
        }
        
        // Update the hidden input value
        hiddenInput.value = variantId;
        
        // Update any quick add buttons or forms with the variant ID
        const quickAddButtons = productCard.querySelectorAll('button[name="add"], .quick-add__submit');
        quickAddButtons.forEach(button => {
          button.dataset.variantId = variantId;
        });
        
        // Update any existing variant selectors in the card (if any)
        const cardVariantInputs = productCard.querySelectorAll('input[name*="option"], select[name*="option"]');
        cardVariantInputs.forEach(input => {
          if (input.value === event.target.dataset.swatchValue) {
            if (input.type === 'radio') {
              input.checked = true;
            } else if (input.tagName === 'SELECT') {
              input.value = event.target.dataset.swatchValue;
            }
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        
        // Dispatch a custom event for other scripts to listen to
        const changeEvent = new CustomEvent('cardVariant:change', {
          detail: {
            variantId: variantId,
            productHandle: productHandle,
            swatchValue: event.target.dataset.swatchValue,
            productCard: productCard
          }
        });
        productCard.dispatchEvent(changeEvent);
        
      }
    }
  });
});

